var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0051 4.35708L22.6429 8.99485M14.9133 26H27.2807M2.54592 19.8163L1 26L7.18369 24.4541L25.0947 6.54302C25.6744 5.96321 26 5.17693 26 4.35708C26 3.53724 25.6744 2.75096 25.0947 2.17115L24.8288 1.90525C24.249 1.32562 23.4628 1 22.6429 1C21.8231 1 21.0368 1.32562 20.457 1.90525L2.54592 19.8163Z",
    stroke: "#262B41",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenActive);
export default __webpack_public_path__ + "static/media/pen-active.8943424cb43bf7c61946d3e806246448.svg";
export { ForwardRef as ReactComponent };